import { inject } from "@angular/core";
import { FilerInformationService } from "../services";
import { map } from "rxjs/operators";
import { AccessEthicsTypesEnum as Ethics } from "src/app/app.model";
import { CanActivateFn } from "@angular/router";

export const OnlyOfficerGuard: CanActivateFn = () => inject(FilerInformationService).current$.pipe(
    map((it) => it?.entityTypeId ?? Ethics.Undetermined),
    map((it) => it !== Ethics.Undetermined)
);
